import { AlertTriangle } from "lucide-react";

export const B360_LEVELS = {
  4: { short: "Potable Use Not Recommended", accent: "#dc2626", bg: "bg-rose-50",    border: "border-rose-300",    text: "text-rose-900" },
  3: { short: "Treatment Required",          accent: "#ea580c", bg: "bg-orange-50",  border: "border-orange-300",  text: "text-orange-900" },
  2: { short: "Improvement Recommended",     accent: "#ca8a04", bg: "bg-amber-50",   border: "border-amber-300",   text: "text-amber-900" },
  1: { short: "Results Acceptable",          accent: "#16a34a", bg: "bg-emerald-50", border: "border-emerald-300", text: "text-emerald-900" },
};

const ALERT_ACCENT = { red: "#dc2626", orange: "#ea580c", yellow: "#ca8a04" };

export const Bore360Panel = ({ assessment, dataTestId = "bore360-panel", children }) => {
  if (!assessment) return null;
  const cfg = B360_LEVELS[assessment.level] || B360_LEVELS[2];
  return (
    <section
      data-testid={dataTestId}
      className={`rounded-3xl border-2 ${cfg.border} ${cfg.bg} p-6 lg:p-7`}
      style={{ borderLeftWidth: 8, borderLeftColor: cfg.accent }}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] font-bold" style={{ color: cfg.accent }}>
            Bore 360 Decision Matrix
          </div>
          <div data-testid={`${dataTestId}-label`} className={`mt-1.5 font-display text-lg sm:text-xl font-bold leading-snug ${cfg.text}`}>
            {assessment.label}
          </div>
        </div>
        <div className="flex flex-col items-end gap-1.5">
          <span data-testid={`${dataTestId}-level`} className="px-3 py-1 rounded-full text-xs font-bold text-white" style={{ background: cfg.accent }}>
            Level {assessment.level} of 4
          </span>
          <div className="flex gap-1" aria-hidden>
            {[1, 2, 3, 4].map((n) => (
              <span
                key={n}
                className="w-6 h-1.5 rounded-full"
                style={{ background: n <= assessment.level ? cfg.accent : "#cbd5e1" }}
              />
            ))}
          </div>
        </div>
      </div>

      <p data-testid={`${dataTestId}-wording`} className="mt-3 text-[15px] leading-relaxed text-slate-800">
        {assessment.wording}
      </p>

      {(assessment.combination_alerts || []).length > 0 && (
        <div data-testid={`${dataTestId}-alerts`} className="mt-4 space-y-2.5">
          {assessment.combination_alerts.map((a) => (
            <div
              key={a.key}
              data-testid={`${dataTestId}-alert-${a.key}`}
              className="rounded-xl bg-white/70 border border-slate-200 p-3.5"
              style={{ borderLeft: `4px solid ${ALERT_ACCENT[a.severity] || "#334155"}` }}
            >
              <div className="flex items-center gap-1.5 text-sm font-bold text-slate-900">
                <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" style={{ color: ALERT_ACCENT[a.severity] || "#334155" }} />
                {a.title}
              </div>
              <p className="mt-1 text-[13px] leading-relaxed text-slate-700">{a.text}</p>
            </div>
          ))}
        </div>
      )}

      {assessment.safeguard_note && (
        <p className="mt-4 text-[11.5px] leading-relaxed text-slate-500 italic">{assessment.safeguard_note}</p>
      )}
      {children}
    </section>
  );
};
